<template>
  <div>
    <b-modal
      id="etrail-modal"
      ref="etrail-modal-ref"
      hide-footer
      :title="modalTitle"
      @hidden="$v.$reset()"
    >
      <div v-if="booking && booking.user_information" class="etrail-block">
        <div>
          <p>Booking Number: {{ booking.user_information.bookingNumber }}</p>
        </div>

        <template v-if="!sent">
          <div v-if="!isInTrip && !isUrgent">
            Please complete the form below to send us your message.
            <span v-if="estimatedResponseHours"> We will respond within {{ estimatedResponseHours }} hours, typically sooner.</span>
            <span v-else> We will respond as soon as possible.</span>
          </div>

          <div v-if="isInTrip">
            <p>
              Please complete the form below to send us your message.
              <span v-if="estimatedResponseHours"> We will respond within {{ estimatedResponseHours }} hours, typically sooner.</span>
              <span v-else> We will respond as soon as possible.</span>
            </p>
          </div>

          <div v-if="isUrgent">
            <p>Please complete the form below to send us your urgent message.</p>
            <div class="d-flex align-items-center">
              <img class="whats-app-img pr-2" src="https://cdn.trailfinders.com/whats-app-logo.png" alt="whats-app-green-logo">
              <p class="m-0">Alternatively, if you have the ViewTrail App and select 'Contact Us' from there, you will be able to send us a WhatsApp.</p>
            </div>
            <p class="mt-2">You can also call us on <a :href="country === 'UK' ? 'tel:02073681381' : 'tel:+35318814982'" class="contact-us-tel">{{ country === 'UK' ? '0207 368 1381' : '+ 353 1 881 4982' }}</a>, however a message often works best so that if necessary, we can investigate before we respond to you. Whichever channel you choose our Duty Officer team will respond as soon as they can.</p>
          </div>

          <p class="mt-2">Please be aware that this message and any response will display in the Communications section of ViewTrail and be visible to anyone on the booking with ViewTrail access</p>

          <div>
          <b-form class="etrail-form" @submit.stop.prevent="onSubmit">
            <!-- @ TODO - REMINDER SET FOR 14/10/26 TO REMOVE IF NOT NEEDED -->
            <!-- <b-row class="mt-3">
              <b-col>
                <div class="mec-highlight p-3 mb-3">
                  <b-form-group
                    v-slot="{ ariaDescribedby }"
                    label="Does this relate to the unrest in the Middle East?"
                    label-class="font-weight-bold mb-1">
                    <b-form-radio-group
                      id="radio-mec"
                      v-model="form.mec"
                      :aria-describedby="ariaDescribedby"
                      name="radio-mec"
                      class="d-flex">
                      <b-form-radio :value="true" class="mr-3">Yes</b-form-radio>
                      <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </b-col>
            </b-row> -->
            <b-row class="mt-4">
              <b-col>
                <label>Submitter</label>
                <b-form-select
                  id="select-passenger"
                  v-model="$v.form.passenger.$model"
                  v-bind="{ passenger }"
                  :state="validateState('passenger')">
                  <option :value="null">Please Select Name...</option>
                  <option v-for="(item, index) in paxNames" :key="index" :value="item">
                    {{ item.name }}
                  </option>
                </b-form-select>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col>
                <label>Email (Edit as required)</label>
                <b-form-input
                  id="input-email-etrail"
                  v-model.trim="$v.form.email.$model"
                  type="text"
                  v-bind="{ passenger }"
                  class="mb-2"
                  :state="validateState('email')" />
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col>
                <label>Preferred Contact Number (Edit as required)</label>
                <b-form-select
                  v-if="phoneOptions.length && !manualPhone"
                  :value="form.tel1"
                  :options="[...phoneOptions, { text: 'Enter a different number', value: '__manual__' }]"
                  :state="validateState('tel1')"
                  @change="onPhoneOptionChange"
                />
                <b-form-input
                  v-else
                  id="input-tel1"
                  v-model.trim="$v.form.tel1.$model"
                  type="text"
                  :state="validateState('tel1')" />
                <small v-if="$v.form.tel1.$error" class="d-block text-danger">A phone number must be entered. If you would prefer to be contacted by email, please state this in your message below.</small>
              </b-col>
            </b-row>

            <div v-if="!isUrgent">
              <label>{{ 'Please select a topic' }}</label>
              <b-row class="mt-2">
                <b-col>
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      id="radio-query-category-1"
                      v-model="$v.form.category.$model"
                      :options="queryOptionsCol1"
                      :aria-describedby="ariaDescribedby"
                      name="radio-query-category-1"
                      stacked />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                      id="radio-query-category-2"
                      v-model="$v.form.category.$model"
                      :options="queryOptionsCol2"
                      :aria-describedby="ariaDescribedby"
                      name="radio-query-category-2"
                      stacked />
                  </b-form-group>
                </b-col>
              </b-row>
              <small v-if="$v.form.category.$error" class="d-block text-danger mt-1">Please select a topic before submitting.</small>
            </div>

            <b-row class="mt-2">
              <b-col>
                <label>Your message</label>
                <b-form-textarea
                  class="your-message-textarea"
                  id="input-message"
                  v-model.trim="$v.form.message.$model"
                  placeholder="Character limit of 800 (including spaces)"
                  rows="3"
                  max-rows="6"
                  :state="validateState('message')" />
              </b-col>
            </b-row>
            <b-row v-if="hasMultiplePassengers && communicationsPrivicyEnabled" class="mt-2">
              <b-col>
                <b-form-checkbox
                  id="etrail-share-checkbox"
                  v-model="form.shareWithOtherPassengers"
                  name="etrail-share-checkbox"
                >
                  Allow other guests on this booking to view this communication
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row class="flex-row">
              <button
                :disabled="disabled"
                type="submit"
                class="ml-lg-3 address-block-btn address-btn-submit justify-content-center">
                <span>Submit</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
              </button>
            </b-row>
          </b-form>
        </div>
        </template>
        <b-alert v-if="sent" show class="text-center" variant="success">{{ sent }}</b-alert>
        <b-alert v-else-if="maxSent" show class="text-center" variant="info">
          Maximum amount of querys have been submitted using this email address.
        </b-alert>
        <b-alert v-else-if="submissionError" show class="text-center" variant="danger">
          {{ submissionErrorMessage || 'Sorry, we were unable to send your message.' }} Please try again or call us on
          <a :href="country === 'UK' ? 'tel:02073681381' : 'tel:+35318814982'" class="contact-us-tel">
            {{ country === 'UK' ? '0207 368 1381' : '+ 353 1 881 4982' }}
          </a>.
        </b-alert>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { required, maxLength, minLength, requiredIf } from 'vuelidate/lib/validators'
import { isOfficeOpen, getField14 } from '../services'
import { mapActions, mapGetters } from 'vuex'
import { COMMUNICATIONS_PRIVACY_ENABLED } from '../../../lib/feature-flags';

export default {
  props: {
    booking: {
      type: Object,
      default: null,
    },
    source: {
      type: String,
      default: null,
    },
    contactMode: {
      type: String,
      default: 'pre-travel',
      validator: (val) => ['pre-travel', 'in-trip', 'urgent'].includes(val),
    },
  },
  data() {
    return {
      communicationsPrivicyEnabled: COMMUNICATIONS_PRIVACY_ENABLED,
      disabled: false,
      maxSent: false,
      submissionError: false,
      submissionErrorMessage: null,
      manualPhone: false,
      sent: null,
      form: {
        passenger: null,
        isOfficeOpen: true,
        isUrgent: false,
        email: this.email,
        tel1: '',
        tel2: '',
        tel3: '',
        phoneNumberNotOnFile: '',
        message: '',
        category: null,
        categoryId: null,
        isAway: false,
        internalEmail: false,
        extrnalEmail: false,
        passengerEmail: false,
        status: 'unchecked',
        source: this.source,
        field14: '',
        sourceId: 'DVT',
        otherPassengerNumbers: '',
        contactType: this.contactMode,
        // @ TODO - REMINDER SET FOR 14/10/26 TO REMOVE IF NOT NEEDED
        mec: false,
        shareWithOtherPassengers: false,
      },
    }
  },
  validations: {
    form: {
      email: {
        required,
      },
      passenger: {
        name: {
          required,
        },
      },
      message: {
        required,
        maxLength: maxLength(800),
      },
      tel1: {
        required,
        minLength: minLength(8),
      },
      category: {
        required: requiredIf(function () {
          return !this.isUrgent
        }),
      },
    },
  },
  computed: {
    ...mapGetters({
      category: 'faq/getCurrentCategory',
      area: 'faq/getCurrentArea',
      email: 'booking/getEmail',
      tel1: 'booking/getTel1',
      tel2: 'booking/getTel2',
      tel3: 'booking/getTel3',
      bookingData: 'booking/getBooking',
      paxNames: 'booking/getBookingPassengers',
      country: 'booking/getCountry',
      etrailCategories: 'communications/getEtrailCategories',
      departureDate: 'booking/getDeptDate'
    }),
    isUrgent() {
      return this.contactMode === 'urgent'
    },
    hasMultiplePassengers() {
      return !!(this.paxNames && this.paxNames.length > 1)
    },
    isInTrip() {
      return this.contactMode === 'in-trip'
    },
    modalTitle() {
      if (this.sent) {
        return this.contactMode === 'urgent' ? 'Urgent Assistance - Message Sent' : 'Message Sent'
      }
      if (this.contactMode === 'urgent') return 'Urgent Assistance'
      if (this.contactMode === 'in-trip') return 'Contact Us'
      return 'Contact Us'
    },
    passenger() {
      return this.form.passenger
    },
    queryOptions() {
      return [...this.etrailCategories]
        .sort((a, b) => a.title.localeCompare(b.title))
        .map((category) => ({
          text: category.title,
          value: category.title,
        }))
    },
    categoryIdByTitle() {
      return this.etrailCategories.reduce((acc, category) => {
        acc[category.title] = category._id
        return acc
      }, {})
    },
    estimatedPriority() {
      if (this.isUrgent) return 'UA'
      if (this.isInTrip) return 'IT'
      if (!this.bookingData || !this.bookingData.booking_information) return null
      try {
        const returnDate = new Date(this.bookingData.booking_information.vtdate_return)
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        if (returnDate <= yesterday) return 'RT'
        if (!this.departureDate) return null
        const departureDate = new Date(this.departureDate)
        const daysToDeparture = Math.ceil((departureDate.getTime() - Date.now()) / (1000 * 3600 * 24))
        return daysToDeparture > 30 ? 'P3' : 'P2'
      } catch (err) {
        return null
      }
    },
    selectedCategory() {
      return this.etrailCategories.find((cat) =>
        this.form.categoryId ? cat._id === this.form.categoryId : cat.title === this.form.category,
      )
    },
    estimatedResponseHours() {
      // Urgent Assistance has no SLA - never estimate a response time for it.
      if (this.isUrgent) return null
      const priority = this.estimatedPriority
      if (!priority || !this.selectedCategory) return null
      return (this.selectedCategory.responseHours && this.selectedCategory.responseHours[priority]) || null
    },
    queryOptionsCol1() {
      return this.queryOptions.slice(0, Math.ceil(this.queryOptions.length / 2))
    },
    queryOptionsCol2() {
      return this.queryOptions.slice(Math.ceil(this.queryOptions.length / 2))
    },
    phoneOptions() {
      if (!this.passenger) return []

      const isPlaceholder = (num) => {
        const stripped = num.replace(/\s+/g, '').toLowerCase()
        return stripped === 'pleaseadvise' || /^ple\*+ise$/i.test(stripped)
      }

      const tel = this.passenger.tel
      if (!tel || !tel.trim() || isPlaceholder(tel)) return []

      return [{ text: tel.trim(), value: tel.trim() }]
    },
  },
  watch: {
    passenger() {
      if (this.passenger !== null) {
        this.manualPhone = false
        this.form.tel1 = this.passenger.tel || ''
        this.form.tel2 = this.tel2
        this.form.tel3 = this.tel3
        // Guest/non-lead passengers often have no email on file — fall back
        // to the booking-level (account) email rather than wiping the field
        // blank, same as the initial value seeded in data().
        this.form.email = this.passenger.email || this.email
      }
    },
    'form.category'(newVal) {
      this.form.categoryId = newVal ? this.categoryIdByTitle[newVal] || null : null
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name]
      return $dirty ? !$error : null
    },
    onPhoneOptionChange(val) {
      if (val === '__manual__') {
        this.manualPhone = true
        this.form.tel1 = ''
      } else {
        this.form.tel1 = val
      }
    },
    ...mapActions({
      sendEtrail: 'contactUs/sendEtrailAction',
      setCurrentAreaAction: 'faq/setCurrentAreaAction',
      setCurrentCategoryAction: 'faq/setCurrentCategoryAction',
      setEtrailsAction: 'communications/setEtrailsAction'
    }),

    show: function () {
      this.$refs['etrail-modal-ref'].show()
    },

    async onSubmit() {
      this.disabled = true
      setTimeout(() => {
        this.disabled = false
      }, 5000)
      this.maxSent = false
      this.$v.form.$touch()
      if (this.$v.form.$anyError) {
        return
      }
      this.$store.dispatch('spinner/updateLoadingAction', true, { root: true })
      this.form.source = this.source
      this.form.isAway = this.isAway()
      this.form.isUrgent = this.isUrgent
      this.form.contactType = this.contactMode
      if (this.isUrgent) this.form.category = 'Urgent Assistance'
      // Both already swallow their own request errors and resolve to null —
      // default to safe fallbacks here so a failure of either (an unrelated
      // backend, not the etrails API) can't crash the submission before it
      // ever reaches sendEtrail.
      let officeDetails = (await isOfficeOpen()) || { officeOpen: false }
      this.form.isOfficeOpen = officeDetails.officeOpen
      this.form.field14 = (await getField14(this.booking.booking_information.custno)) || ''
      this.form.CDB = this.booking.booking_information.custno
      this.form.logname = this.booking.booking_information.logname
      this.form.vtdate_authorised = this.booking.booking_information.vtdate_authorised
      this.form.vtdate_return = this.booking.booking_information.vtdate_return
      this.checkPhoneNumberOnFile(this.form.tel1)
      let res = await this.sendEtrail(this.form)
      this.$store.dispatch('spinner/updateLoadingAction', false, { root: true })
      if (!res) {
        this.submissionErrorMessage = null
        this.submissionError = true
        setTimeout(() => {
          this.submissionError = false
        }, 10000)
        return
      }
      if (
        res.msg === 'Maximum amount of querys have been submitted using this email address.'
      ) {
        this.maxSent = true
        setTimeout(() => {
          this.maxSent = false
        }, 5000)
      } else if (res.error) {
        this.submissionErrorMessage = res.message || null
        this.submissionError = true
        setTimeout(() => {
          this.submissionError = false
          this.submissionErrorMessage = null
        }, 10000)
      } else {
        this.setEtrailsAction(this.booking.user_information.bookingNumber)
        this.sent = res.data
        this.setCurrentAreaAction('')
        this.setCurrentCategoryAction('')
        setTimeout(() => {
          this.form = {
            passenger: this.paxNames
              ? [...this.paxNames].filter(
                  (pax) =>
                    pax.name ===
                    `${this.bookingData.booking_information.lead_firstname} ${this.bookingData.booking_information.lead_surname}`
                )[0]
              : '',
            email: this.email,
            tel1: this.booking
              ? this.booking.user_information.bookingAddress.tel.tel_01.number
              : '',
            message: '',
            internalEmail: false,
            extrnalEmail: false,
            passengerEmail: false,
            category: null,
            categoryId: null,
            isAway: this.isAway(),
            field14: this.field14,
            sourceId: 'DVT',
            isOfficeOpen: officeDetails.officeOpen,
            isUrgent: this.isUrgent,
            source: this.source,
            phoneNumberNotOnFile: '',
            otherPassengerNumbers: '',
            contactType: this.contactMode,
            // @ TODO - REMINDER SET FOR 14/10/26 TO REMOVE IF NOT NEEDED
            mec: false,
          }
          this.sent = null
          if (this.$refs['etrail-modal-ref']) {
            this.$refs['etrail-modal-ref'].hide()
          }
        }, 3000)
      }
    },
    isAway: function () {
      const retDate = new Date(this.bookingData.booking_information.vtdate_return).getTime()
      const dnow = new Date().getTime()
      if (this.bookingData.booking_information.departed === 'true' && dnow < retDate) {
        return true
      }
      return false
    },
    checkPhoneNumberOnFile(phoneNumber) {
      const otherNumbers = this.paxNames.filter(
        (item) => this.formatPhoneNumber(item.tel) === this.formatPhoneNumber(this.form.tel1)
      )
      if (
        this.formatPhoneNumber(this.tel1) !== this.formatPhoneNumber(phoneNumber) &&
        this.formatPhoneNumber(this.tel2) !== this.formatPhoneNumber(phoneNumber) &&
        this.formatPhoneNumber(this.tel3) !== this.formatPhoneNumber(phoneNumber) &&
        !otherNumbers.length
      ) {
        this.form.tel2 = this.tel2
        this.form.tel3 = this.tel3
        this.form.otherPassengerNumbers = this.paxNames.filter((item) => {
          if (item.name !== this.passenger.name) {
            return item
          }
        })
        return (this.form.phoneNumberNotOnFile = true)
      }
      return (this.form.phoneNumberNotOnFile = false)
    },
    formatPhoneNumber(number) {
      if (!number) return ''
      let tempNumber = number
      if (tempNumber[tempNumber.length - 1] === 'H') {
        tempNumber = tempNumber.split('')
        tempNumber.pop()
        tempNumber = tempNumber.join('')
      }
      tempNumber = tempNumber.split(' ')
      tempNumber = tempNumber.join('')
      return tempNumber
    },
  },
}
</script>

<style scoped>
@import  './styles.scss';

.your-message-textarea {
  overflow-y: visible !important;
  resize: none !important;
}
</style>
